'use strict';

import EventEmitter from './EventEmitter';
import EventEmitterProxy from './EventEmitterProxy';
import EventHandle from './EventHandle';
import EventHandler from './EventHandler';

export default EventEmitter;
export {EventEmitter, EventEmitterProxy, EventHandle, EventHandler};
